module.exports = __webpack_public_path__ + "e2038c5ea26efce7cdc91129caf0e495.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/css/res/fonts/AvenirNext/276b3566-1c3b-4bc1-8915-15314f091f29.ttf
// module id = 1113
// module chunks = 0